import { Pagination } from '@api/abstracts/models';
import { Kitchen, KitchenVariant } from '@shared/models';
import {
  ElasticSearchResponse,
  KitchenDocument,
  KitchenDocumentVisual,
  PayloadModels,
} from '@shared/services/elastic-search/models';

export const modelsSerializer = (
  models: ElasticSearchResponse<KitchenDocument>,
  query: PayloadModels,
  isExtendedSearch: boolean
): Pagination<Kitchen> => {
  const modelsSerialized = models.hits.hits.map((model) => {
    const s = model._source;
    return {
      id: s.nid?.[0],
      name: s.nom_modele?.[0],
      price: s.default_price_with_currency?.[0],
      ecoPart: s.default_ecopart_with_currency?.[0],
      implantation: {
        type: '',
        surface: '',
        shortRef: s.short_ref?.[0],
      },
      variants: variantsSerializer(s.field_visuels_principaux),
      url: s.url?.[0],
    } as Kitchen;
  });
  return {
    items: modelsSerialized,
    currentPage: undefined!,
    itemsPerPage: query.itemsToFetch,
    totalItems: models.hits.total.value ?? 0,
    totalPages: undefined!,
    isExtendedSearch,
  };
};

const variantsSerializer = (variants: KitchenDocumentVisual[]): KitchenVariant[] =>
  variants.map((v) => ({
    id: v.id,
    name: v.name,
    shortName: v.stickerName,
    image: v.image,
    colorPreview: v.colorPreview.link ? v.colorPreview : undefined,
    colorRgb: v.filters?.[0]?.rgb ?? undefined,
    fronts: v.filters?.map((f) => ({ key: f.tid, label: f.name })),
  }));
